module.exports = __webpack_public_path__ + "img/pluto105.9d72ed67.jpg";